import { Component } from '@theme/component';

/** @extends {Component<{ details: HTMLDetailsElement, trigger: HTMLElement }>} */
class ZayaNavigation extends Component {
  requiredRefs = ['details', 'trigger'];
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.addEventListener('keydown', this.#onKeydown, { signal });
    document.addEventListener('pointerdown', this.#onOutside, { signal });
    this.addEventListener('focusout', this.#onFocusout, { signal });
    window.matchMedia('(min-width: 1100px)').addEventListener('change', this.#onResize, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  /** @param {KeyboardEvent} event */
  #onKeydown = (event) => {
    if (event.key !== 'Escape' || !this.refs.details.open) return;
    event.preventDefault();
    this.refs.details.open = false;
    this.refs.trigger.focus();
  };

  /** @param {PointerEvent} event */
  #onOutside = (event) => {
    if (event.target instanceof Node && !this.contains(event.target)) this.refs.details.open = false;
  };

  /** @param {FocusEvent} event */
  #onFocusout = (event) => {
    if (event.relatedTarget instanceof Node && !this.contains(event.relatedTarget)) this.refs.details.open = false;
  };

  #onResize = () => { this.refs.details.open = false; };
}

if (!customElements.get('zaya-navigation')) customElements.define('zaya-navigation', ZayaNavigation);
